import * as React from 'react';
import Modal from 'shared/components/Modal';
import { CompareResultObject } from '../../models/CompareResultObject';
// #region HCL
import CompareItemsTableHCL from './CompareItemsTable.HCL';
// #endregion

export interface CompareItemsModalProps {
	/**
	 * The compare items
	 *
	 * @type {CompareResultObject[]}
	 * @memberof CompareItemsModalProps
	 */
	resultItems: CompareResultObject[];

	/**
	 * What happens when we toggle the modal visibility.
	 *
	 * @memberof CompareItemsModalProps
	 */
	onModalToggle: (showModal: boolean) => void;

	/**
	 * Controls whether the modal is open.
	 *
	 * @type {boolean}
	 * @memberof CompareItemsModalProps
	 */
	popup: boolean;
}

/**
 * Modal containing a table of hawksearch result items to be compared
 */
function CompareItemsModal({ resultItems, onModalToggle, popup }: CompareItemsModalProps) {
	if (resultItems == null || resultItems.length == 0 || !popup) {
		return null;
	}

	return (
		<Modal
			size="full_width"
			isOpen={popup}
			hideCloseButton={false}
			closeModal={() => {
				onModalToggle(false);
			}}
			renderTitle={() => 'Compare Items'}
			renderActions={() => (
				<>
					<button
						type="button"
						onClick={() => onModalToggle(false)}
						className="roc-btn roc-modal__btn roc-modal__btn-cancel"
						data-testid="compare-close-btn"
					>
						Close
					</button>
				</>
			)}
		>
			{/* #region HCL */}
			<CompareItemsTableHCL compareItems={resultItems} />
			{/* #endregion HCL */}
		</Modal>
	);
}

export default CompareItemsModal;
